import { Component, OnInit, Inject, ViewChild } from "@angular/core";
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {SelectItem} from 'primeng/api';
import { locale as english } from './i18n/en';
import { locale as dutch } from './i18n/nl';
import { AppConfig } from '../../../core/configs/app-config';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {MedewerkerOverzicht} from '../../../model/dto/medewerkers/overzicht';
import { Router } from '@angular/router';
import {UserService } from "../../../core/services/user.service";
import { HttpClient } from '@angular/common/http';

@Component({
    selector   : 'overzicht',
    templateUrl: './overzicht.component.html',
    styleUrls  : ['./overzicht.component.scss']
})



export class OverzichtComponent implements OnInit
{
    //medewerkers: MedewerkerOverzicht[] = [];  
    ELEMENT_DATA: MedewerkerOverzicht[] = [];
    afdelingen: SelectItem[] = [];
    selectedAfdelingen: any[] = [];
    zoektext: string = "";
    uitdienstvalue: boolean;
    config: any;
    dataSource: any;

    /**
     * Constructor
     *
     * @param {FuseTranslationLoaderService} _fuseTranslationLoaderService
     */
    
    constructor(private router: Router,private _fuseTranslationLoaderService: FuseTranslationLoaderService, private userService: UserService, @Inject(HttpClient) private http?: HttpClient)
    {
        this.config = {
            "SERVERPROTOCOL": AppConfig.ApiProtocol,
            "SERVERURL": AppConfig.ApiLoginHost,
            "SERVERPORT": AppConfig.ApiPort,
            "APPLICATIONID": AppConfig.ApiApplicationId,
            "METHOD": AppConfig.ApiMethod,
            "LOGINURL": AppConfig.ApiLoginUrl,
            "STACKURL": AppConfig.ApiUrl
          };
        this._fuseTranslationLoaderService.loadTranslations(english, dutch);

    }


    displayedColumns: string[] = ['Naam', 'Afdeling'];
    
    cars: SelectItem[];
  
    @ViewChild(MatSort) sort: MatSort;
    ngOnInit(): void {


        this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
        
  
      console.log(this.userService.getAuthenticationtoken());

      let conString = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + "/api/employees/department/overview";
  
        var get = this.http.get(conString);
        get.subscribe(     
        (results: any) => {
        console.log(results);
        for (var result of  results){ 
            this.afdelingen.push(<SelectItem>{ label:result["Afdeling"], value:result["AfdID"]});
        }  
        console.log(this.afdelingen);
    //    this.loadingafdelingen = false;
        },
        (error) => {
        console.error(error);
        });


     conString = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + "/api/employees/overview";

        var get = this.http.get(conString);
        console.log(conString);
        get.subscribe((results:any) => {
          console.log(results);
          for (var result of results){ 
            this.ELEMENT_DATA.push(<MedewerkerOverzicht>{MedewerkerID:result["MedewerkerID"], Naam:result["CplNaam"], Afdeling:result["Afdeling"]}); 
          }  
          this.dataSource.sort = this.sort;
        },
        (error) => {
          console.error(error);
        });

        console.log(this.ELEMENT_DATA);
        
        
    }

    getRecord(medewerkerid){
        console.log(medewerkerid);
        this.router.navigate(['/employees/edit', medewerkerid ]);
    }

    submitFilter(){
        this.ELEMENT_DATA = [];
        
        console.log(this.zoektext);
      
        let conString: string = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + "/api/employees/filter";
        var body = {
          "AfdIDs": this.selectedAfdelingen,
          "Zoektext": this.zoektext,
          "UitDienst" : this.uitdienstvalue
         };
         console.log(body);
        var post = this.http.post(conString, body);
        post.subscribe(     
        (results:any) => {
          for (var result of results){ 
            this.ELEMENT_DATA.push(<MedewerkerOverzicht>{MedewerkerID:result["MedewerkerID"], Naam:result["CplNaam"], Afdeling:result["Afdeling"]}); 
          }  
          this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
          this.dataSource.sort = this.sort;
      console.log(this.ELEMENT_DATA);
        },
        (error) => {
          console.error(error);
        });
       
      }
}
